import React from 'react';
import * as Redux from 'react-redux';
import {
  useParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

import checkRouteOnLoad from '../actions/check-route-on-load';
import changeToNextStepForPreloadedCustomer from '../actions/change-to-next-step-for-preloaded-customer';
import fetchGroup from '../actions/fetch-group';
import fetchDynamicContent from '../actions/fetch-dynamic-content';
import { CustomerDetailsModal } from '../components/customer-details-modal/';
import Loading from '../components/loading';

function GroupContainer(props) {
  const location = useLocation();
  const { groupSlug } = useParams();
  const dispatch = Redux.useDispatch();
  const {
    selectedDevices: { model },
    group,
    repair,
    contact: { customerDetailsPreloaded = false },
    dynamicContent,
  } = Redux.useSelector(state => state);
  const [modalOpen, setModalOpen] = React.useState(
    !customerDetailsPreloaded && !model.id
  );
  const [searchParams] = useSearchParams();
  const msisdn = searchParams.get('msisdn') || searchParams.get('msdn') || '';
  const navigate = useNavigate();
  const loading = group.loading || dynamicContent.loading;

  React.useEffect(() => {
    if (repair.createdAt) {
      navigate(`../tracking/${repair.id}`);
    }
  }, [repair.createdAt, repair.id, navigate]);

  React.useEffect(() => {
    dispatch(fetchDynamicContent(groupSlug));
    dispatch(checkRouteOnLoad(groupSlug, location.pathname));
    if (!group.id) {
      dispatch(fetchGroup(groupSlug, false));
    }
  }, [dispatch, groupSlug, location.pathname, group.id]);

  const TMO_ACS_GROUP_SLUG = '310a6e34-0857-572a-d667-b451b739e2ef';

  const showTmoForBusiness =
    dynamicContent.isTmobileCustomer &&
    groupSlug !== TMO_ACS_GROUP_SLUG &&
    !dynamicContent.isTmoForBusinessGroup;

  if (loading) {
    return <Loading />;
  } else if (dynamicContent.showCustomerLookup && modalOpen && msisdn) {
    return (
      <CustomerDetailsModal
        onConfirm={() => {
          setModalOpen(false);
          dispatch(changeToNextStepForPreloadedCustomer());
        }}
        showTmoForBusiness={showTmoForBusiness}
      />
    );
  } else {
    return props.children;
  }
}

export default GroupContainer;
